import React, { useState, useEffect, useRef } from 'react';

const SKILLS = [
  "front end developer.",
  "web specialist.",
  "UI craftsman.",
  "web experience maker.",
];

const Home = () => {
  const [typed, setTyped] = useState("");
  const phraseRef = useRef(0);
  const charRef = useRef(0);
  const deletingRef = useRef(false);

  useEffect(() => {
    let timeout;
    const tick = () => {
      const phrase = SKILLS[phraseRef.current];
      if (!deletingRef.current) {
        charRef.current++;
        setTyped(phrase.slice(0, charRef.current));
        if (charRef.current === phrase.length) {
          deletingRef.current = true;
          timeout = setTimeout(tick, 1200);
          return;
        }
      } else {
        charRef.current--;
        setTyped(phrase.slice(0, charRef.current));
        if (charRef.current === 0) {
          deletingRef.current = false;
          phraseRef.current = (phraseRef.current + 1) % SKILLS.length;
        }
      }
      timeout = setTimeout(tick, deletingRef.current ? 25 : 50);
    };
    tick();
    return () => clearTimeout(timeout);
  }, []);

  return (
    <section
      id="about"
      style={{
        display: "flex",
        alignItems: "center",
        padding: "40px 24px 30px",
        position: "relative",
        overflow: "hidden",
      }}
    >

      <div style={{ maxWidth: "1100px", margin: "40px auto 20px", width: "100%", position: "relative" }}>
        <div
          className="hero-grid"
          style={{
            display: "grid",
            gap: "35px",
            alignItems: "center",
          }}
        >
          {/* LEFT — text */}
          <div style={{ animation: "fadeUp 0.8s ease both" }}>

            {/* Name */}
            <h1 className="text-5xl font-bold mb-4">
              <span className="text-pink-400">Adam Smetana</span>
              <span className="inline-block w-[2px] h-8 bg-blue-400 ml-1 animate-pulse">|</span>
            </h1>

            {/* Tagline */}
            <div className="subheading font-semibold" style={{ fontSize: "18px", marginTop: "12px", marginBottom: "16px" }}>
              <span className="text-gray-300">I build the parts of the web </span><span className="text-teal-400" style={{ fontWeight: 600 }}>people actually notice.</span>
            </div>

            {/* Range */}
            <p className="text-gray-300" style={{ fontSize: "16px", fontWeight: 500, marginBottom: "30px" }}>
              I handle national brand rebuilds, keep long-running client sites healthy, and build my own products when I can.
            </p>

            {/* Availability */}
            <div style={{
              display: "inline-flex", alignItems: "center", gap: "8px",
              padding: "6px 20px", marginBottom: "40px",
              background: "#071310d1",
              border: "1px solid var(--border)",
              color: "white",
            }}>
              <span style={{ position: "relative", width: "8px", height: "8px" }}>
                <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "rgb(45,212,191)" }} />
                <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "rgb(45,212,191)", animation: "pulse-ring 2s ease-out infinite" }} />
              </span>
              <span style={{ fontSize: "15px", color: "white" }}>Currently accepting new projects</span>
            </div>

            {/* CTAs */}
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <button
                className="cta-primary bg-gradient-to-r from-teal-500 to-teal-600 text-white font-semibold px-6 py-3 rounded-lg hover:from-teal-400 hover:to-teal-500 transition-all duration-150"
                onClick={() => document.getElementById("work")?.scrollIntoView({ behavior: "smooth" })}
              >
                View My Work
              </button>
              <button
                className="cta-secondary"
                onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              >
                Get In Touch
              </button>
            </div>

          </div>

          {/* RIGHT — code card */}
          <div id="terminal" style={{
            width: "100%", maxWidth: "420px", margin: "0 auto",
            background: "linear-gradient(135deg, #241a3d 0%, #1a1330 100%)",
            border: "1px solid rgba(124,58,237,0.3)",
            borderRadius: "5px",
            padding: "28px",
            boxShadow: "0 40px 80px rgba(0,0,0,0.6)",
            animation: "float 5s ease-in-out infinite",
            fontFamily: "'Courier New', monospace",
            fontSize: "calc(0.82rem + 1.5px)",
            lineHeight: "1.9",
          }}>
            {/* Browser chrome dots */}
            <div style={{ display: "flex", gap: "7px", marginBottom: "20px" }}>
              {["#ff5f57", "#febc2e", "#28c840"].map(c => (
                <div key={c} style={{ width: "11px", height: "11px", borderRadius: "50%", background: c }} />
              ))}
            </div>

            <div style={{ color: "#cbd5e1" }}>/* style.css */</div>
            <div><span style={{ color: "#7dd3fc" }}>:root</span> <span style={{ color: "#f5f0ff" }}>{"{"}</span></div>
            <div style={{ paddingLeft: "20px" }}><span style={{ color: "#93c5fd" }}>--name</span><span style={{ color: "#f5f0ff" }}>:</span> <span style={{ color: "#4ade80" }}>"Adam Smetana"</span><span style={{ color: "#f5f0ff" }}>;</span></div>
            <div style={{ paddingLeft: "20px" }}>
              <span style={{ color: "#93c5fd" }}>--role</span>
              <span style={{ color: "#f5f0ff" }}>:</span>{" "}
              <span style={{ color: "#4ade80" }}>
                "{typed}<span style={{ animation: "blink 1s step-end infinite", color: "#4ade80" }}>|</span>"
              </span>
              <span style={{ color: "#f5f0ff" }}>;</span>
            </div>
            <div style={{ paddingLeft: "20px" }}><span style={{ color: "#93c5fd" }}>--location</span><span style={{ color: "#f5f0ff" }}>:</span> <span style={{ color: "#4ade80" }}>"Chicago / Anywhere"</span><span style={{ color: "#f5f0ff" }}>;</span></div>
            <div style={{ paddingLeft: "20px" }}><span style={{ color: "#93c5fd" }}>--focus</span><span style={{ color: "#f5f0ff" }}>:</span> <span style={{ color: "#fb923c" }}>"Web Experiences"</span><span style={{ color: "#f5f0ff" }}>;</span></div>
            <div style={{ paddingLeft: "20px" }}><span style={{ color: "#93c5fd" }}>--available</span><span style={{ color: "#f5f0ff" }}>:</span> <span style={{ color: "#fb923c" }}>flex;</span><span style={{ color: "#f5f0ff" }}>;</span></div>
            <div><span style={{ color: "#f5f0ff" }}>{"}"}</span></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Home;
